document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.fireworks');
  if (!container) return;

  if (typeof Fireworks === 'undefined' || !Fireworks.default) {
    console.error('fireworks-js library not loaded');
    return;
  }

  window._headerFireworks = window._headerFireworks || new Fireworks.default(container, {
    hue: { min: 20, max: 340 },
    gravity: 1.6,
    particles: 60,
    explosion: 18,
    trace: 5,
    brightness: { min: 60, max: 100 },
    boundaries: {
      x: 0, y: 0, width: window.innerWidth, height: window.innerHeight
    },
    sound: { enabled: false }
  });
});

function burstRealFireworks() {
  const fireworks = window._headerFireworks;
  if (!fireworks) return;
  fireworks.launch();
  setTimeout(() => fireworks.stop(), 1500);
}

// This works for buttons present at DOM load
document.querySelectorAll('button.button--addToCart[data-buy-button]').forEach(function(btn){
  btn.addEventListener('click', function() {
    console.log('🔥 BoosterTheme Add to Cart button clicked!');
    setTimeout(burstRealFireworks, 300);
  });
});

// Fallback: catch dynamically added buttons as well!
document.addEventListener('click', function(e) {
  const btn = e.target.closest('button.button--addToCart[data-buy-button]');
  if (btn) {
    setTimeout(burstRealFireworks, 300);
  }
});
